const Err = require( './Err' )

// Common Http Errors

Err.badRequest = Err.extend( 'BadRequest', 400, 'Bad arguments' )
Err.unauthorized = Err.extend( 'Unauthorized', 401, 'Unauthorized' )
Err.forbidden = Err.extend( 'Forbidden', 403, 'Forbidden' )
Err.notFound = Err.extend( 'NotFound', 404, 'Not found' )
Err.requestTimeout = Err.extend( 'RequestTimeout', 408, 'Request timeout' )
Err.conflict = Err.extend( 'Conflict', 409, 'Conflict' )
Err.gone = Err.extend( 'Gone', 410, 'Gone' )

Err.internalError = Err.extend( 'InternalError', 500, 'Internal Error' )
Err.notImplemented = Err.extend( 'NotImplemented', 501, 'Not implemented' )
Err.serviceUnavailable = Err.extend( 'ServiceUnavailable', 503, 'Service unavailable' )

// Other errors

Err.illegalArgument = Err.extend( 'IllegalArgument', 400, 'Illegal argument' ) // use BadRequest code
Err.unknownMessage = Err.extend( 'UnknownMessage', 400, 'Unknown Message' )

module.exports = Err
